module.exports = __webpack_public_path__ + "img/calendar-icon.85aa92d0.svg";